import { ReactComponent as Import } from "@assets/icons/import_icon.svg";

const ImportIcon = (props: any): JSX.Element => {
  return (
    <Import
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default ImportIcon;
